<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  functional: true,
  props: {
    vnodes: {
      type: Object,
      required: true,
    },
  },
  render: (_, context) => context.props.vnodes,
});
</script>
